import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table, Button, Select } from 'antd';


const { Option } = Select;

const MunToleList = () => {
  const [munToles, setMunToles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [size] = useState(20);
  const [sortField, setSortField] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');

  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/mun-tole/pagination';

  useEffect(() => {
    const fetchMunToles = async () => {
      try {
        setLoading(true);
        const response = await axios.get(API_URL, {
          params: { page, size, sortBy: sortField, sortOrder },
        });
        setMunToles(response.data.content);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchMunToles();
  }, [page, size, sortField, sortOrder]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns = [
    {
      title: 'क्र.सं',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'टोल नाम',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'फोन',
      dataIndex: 'phone',
      key: 'phone',
      render: (text) => (text ? text : 'N/A'),
    },
    {
      title: 'इमेल',
      dataIndex: 'email',
      key: 'email',
      render: (text) => (text ? text : 'N/A'),
    },
    {
      title: 'वडा नं',
      dataIndex: 'munWard',
      key: 'munWard',
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0 ? 'odd-row' : 'even-row';
  };


  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-1 pt-20 px-6 md:px-10">
        <Sidebar />
        <div className="w-full md:ml-64 p-4 pt-10">
          <h1 className="text-2xl font-semibold mb-6">टोलको सुची</h1>

          {/* Sorting Section */}
          <div className="flex flex-col md:flex-row md:justify-between items-center mb-6 gap-4">
            {/* Sorting */}
            <div className="flex items-center gap-4">
              <label className="text-sm">Sort By:</label>
              <Select
                onChange={(value) => setSortField(value)}
                value={sortField}
                className="w-32"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="name">टोल नाम</Option>
                <Option value="munWard">वडा नं</Option>
              </Select>
              <label className="text-sm">Order:</label>
              <Select
                onChange={(value) => setSortOrder(value)}
                value={sortOrder}
                className="w-32"
              >
                <Option value="asc">माथिबाट</Option>
                <Option value="desc">तलबाट</Option>
              </Select>
            </div>

            {/* Add Button */}
            <div>
              <Button
                type="primary"
                onClick={() => window.location.href = 'http://localhost:3000/tole/add'}
                size="large"
              >
                Add
              </Button>
            </div>
          </div>

          {/* Data Table */}
          <div className="overflow-x-auto">
            <Table
              dataSource={munToles}
              columns={columns}
              pagination={false}
              loading={loading}
              rowClassName={rowClassName}
              bordered
              className="w-full custom-table"
            />
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-end mt-4 gap-2">
            <Button onClick={() => setPage(page - 1)} disabled={page === 0}>
              Previous
            </Button>
            <Button onClick={() => setPage(page + 1)} disabled={page >= totalPages - 1}>
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MunToleList;
